export default __webpack_public_path__ + "static/media/AM.1f12a39d.svg";